import { useSelector } from 'react-redux';
import { compareDesc, isWithinInterval } from 'date-fns';

import { getDaysOfMonth, isNotAvailableDay } from './helpers';

export function useIsAfterNotAvailableDay(day, checkInDay, checkOutDay) {
    const calendar = useSelector(
        (state) => state.miniBookingWidget?.data?.futureDates
    );

    if (!day) {
        return [false, false, null];
    }

    const checkInDayDateObj = new Date(checkInDay?.date);
    const checkInMonthNo = checkInDayDateObj.getMonth() + 1;
    const checkInYear = checkInDayDateObj.getFullYear();

    const checkOutDayDateObj = new Date(checkOutDay?.date);
    const checkOutMonthNo = checkOutDayDateObj.getMonth() + 1;
    const checkOutYear = checkOutDayDateObj.getFullYear();

    const checkInMonthDays = getDaysOfMonth(
        checkInMonthNo,
        checkInYear,
        calendar
    );

    let checkOutMonthDays = [];
    if (checkInMonthNo !== checkOutMonthNo) {
        checkOutMonthDays = getDaysOfMonth(
            checkOutMonthNo,
            checkOutYear,
            calendar
        );
    }

    const allDays = [...checkInMonthDays, ...checkOutMonthDays];
    const daysBetweenCheckInAndCheckOut = allDays.filter((_day) => {
        const isDayWithinInterval = isWithinInterval(new Date(_day?.date), {
            start: new Date(checkInDay?.date),
            end: new Date(checkOutDay?.date),
        });
        const isBefore =
            compareDesc(new Date(_day?.date), new Date(day?.date)) === 1;
        return isDayWithinInterval && isBefore;
    });

    const daysBetweenCheckInAndCurrentDay = allDays.filter((_day) => {
        const isBefore =
            compareDesc(new Date(_day?.date), new Date(day?.date)) === 1;
        const isAfter =
            compareDesc(new Date(_day?.date), new Date(checkInDay?.date)) ===
            -1;
        return isBefore && isAfter;
    });

    let foundNotAvailableDay = false;
    let allowHover = true;
    let notAvailableDayBetweenCheckInAndCurrentDay;

    for (const _day of daysBetweenCheckInAndCheckOut) {
        if (isNotAvailableDay(_day)) {
            foundNotAvailableDay = true;
            break;
        }
    }

    for (const _day of daysBetweenCheckInAndCurrentDay) {
        if (isNotAvailableDay(_day)) {
            allowHover = false;
            notAvailableDayBetweenCheckInAndCurrentDay = _day;
            break;
        }
    }

    return [
        foundNotAvailableDay,
        allowHover,
        notAvailableDayBetweenCheckInAndCurrentDay,
    ];
}
